var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSierraLogoHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 991.9 278.9",
    style: {
      enableBackground: "new 0 0 991.9 278.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M163.3,215.2h22.3c1,9.2,4.9,16.9,20.2,16.9c10.2,0,17-5.6,17-13.7c0-8.2-4.3-11.1-19.5-13.4 c-26.4-3.5-37.2-11.4-37.2-31.3c0-17.6,14.7-30.7,37.5-30.7c23.2,0,36.8,10.4,38.6,30.8h-21.5c-1.4-9.4-6.9-13.7-17.2-13.7 c-10.2,0-15.4,4.8-15.4,11.7c0,7.4,3.3,10.8,19.2,13.1c24.9,3.2,37.8,9.9,37.8,31.3c0,18.3-15,32.9-39.4,32.9 C177.6,249.1,164.6,235.8,163.3,215.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M259.1,150.5c0-6.5,5.2-11.4,11.8-11.4c6.8,0,12,4.9,12,11.4c0,6.5-5.2,11.4-12,11.4 C264.3,161.9,259.1,157,259.1,150.5z M260.7,172.1h20.8v75.4h-20.8V172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M296.1,210.8v-1.2c0-23.8,16.9-39.2,38.8-39.2c19.5,0,36.8,11.4,36.8,38.3v5.8h-54.3 c0.6,12.5,7.4,19.7,18.7,19.7c9.7,0,14.4-4.2,15.7-10.5h19.7c-2.5,16.3-15.4,25.4-36,25.4C312.6,249.1,296.1,234.8,296.1,210.8z  M351.3,201.7c-0.7-11.4-6.5-16.9-16.4-16.9c-9.4,0-15.7,6.2-17.3,16.9H351.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M385.3,172.1h20.9v14.4c4.8-10.1,12.1-15.4,24.4-15.6v19.5c-15.4-0.1-24.4,4.9-24.4,19.3v37.8 h-20.9V172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M444.2,172.1h20.9v14.4c4.8-10.1,12.1-15.4,24.4-15.6v19.5c-15.4-0.1-24.4,4.9-24.4,19.3v37.8 h-20.9V172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M496.9,226.6c0-17.6,16.1-24.2,39.2-24.2h8.5v-3c0-8.9-2.7-13.8-12.3-13.8 c-8.2,0-12,4.2-12.8,10.7h-19.7c1.3-17.9,15.4-25.8,33.9-25.8s31.6,7.5,31.6,28v49.2h-20.3v-9.1c-4.3,6.1-11,10.7-22.8,10.7 C508.4,249.1,496.9,242.5,496.9,226.6z M544.6,221.1v-6.3h-8.1c-12.1,0-19.2,2.6-19.2,10.7c0,5.5,3.3,9.1,11,9.1 C537.5,234.5,544.6,229.5,544.6,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M616.9,144.5h36.9c24.4,0,39.8,9.9,39.8,31.3v0.6c0,15.6-9.1,23.8-21.2,27.4l27.2,43.8h-24.8 l-24.6-39.8h-10.1v39.8h-23.2V144.5z M653.3,191.9c11.7,0,17.6-4.9,17.6-14.8v-0.6c0-10.5-6.3-14.1-17.6-14.1h-13.1v29.6H653.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M704.4,210.8v-1.2c0-23.8,16.9-39.2,38.8-39.2c19.5,0,36.8,11.4,36.8,38.3v5.8h-54.3 c0.6,12.5,7.4,19.7,18.7,19.7c9.7,0,14.4-4.2,15.7-10.5h19.7c-2.5,16.3-15.4,25.4-36,25.4C721,249.1,704.4,234.8,704.4,210.8z  M759.7,201.7c-0.7-11.4-6.5-16.9-16.4-16.9c-9.4,0-15.7,6.2-17.3,16.9H759.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M796.8,225.2V187h-9.7v-14.8h9.7v-16.3h20.8v16.3h15.9V187h-15.9v36.3c0,6.1,3,8.9,8.4,8.9 c3.2,0,5.5-0.4,7.9-1.4v16.1c-2.9,1-7.1,2-12.7,2C805.4,249,796.8,240.9,796.8,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M843.8,226.6c0-17.6,16.1-24.2,39.2-24.2h8.5v-3c0-8.9-2.7-13.8-12.3-13.8 c-8.2,0-12,4.2-12.8,10.7h-19.7c1.3-17.9,15.4-25.8,33.9-25.8s31.6,7.5,31.6,28v49.2h-20.3v-9.1c-4.3,6.1-11,10.7-22.8,10.7 C855.4,249.1,843.8,242.5,843.8,226.6z M891.6,221.1v-6.3h-8.1c-12.1,0-19.2,2.6-19.2,10.7c0,5.5,3.3,9.1,11,9.1 C884.5,234.5,891.6,229.5,891.6,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M929,150.5c0-6.5,5.2-11.4,11.8-11.4c6.8,0,12,4.9,12,11.4c0,6.5-5.2,11.4-12,11.4 C934.2,161.9,929,157,929,150.5z M930.6,172.1h20.8v75.4h-20.8V172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M971.1,138h20.8v109.6h-20.8V138z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26C44B"
    },
    d: "M172.4,91.8c-0.1,1.2-0.7,2.4-1.8,3.2L14.1,204.5l2.6-17.7l0,0c0.2-1.1,0.8-2.2,1.8-2.9 c0,0,156.5-109.6,156.5-109.6l-2.7,18"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26C44B"
    },
    d: "M114.2,165.8c-0.1,1.2-0.7,2.4-1.8,3.2L8.5,241.7l2.6-17.7l0,0c0.2-1.1,0.8-2.2,1.8-2.9l103.9-72.7 l-2.7,18"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26C44B"
    },
    d: "M108.6,203c-0.1,1.2-0.7,2.4-1.8,3.2L3,278.9l2.6-17.7l0,0c0.2-1.1,0.8-2.2,1.8-2.9l103.9-72.7 l-2.7,18"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26C44B"
    },
    d: "M183.6,17.4c-0.1,1.2-0.7,2.4-1.8,3.2L77.9,93.3l2.6-17.7l0,0c0.2-1.1,0.8-2.2,1.8-2.9L186.2,0 l-2.7,18"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26C44B"
    },
    d: "M178,54.6c-0.1,1.2-0.7,2.4-1.8,3.2L72.3,130.5l2.6-17.7l0,0c0.2-1.1,0.8-2.2,1.8-2.9l103.9-72.7 l-2.7,18"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSierraLogoHome);
export default __webpack_public_path__ + "static/media/sierra_logo_home.7d351f25a025cc79ea40908c6bd038bb.svg";
export { ForwardRef as ReactComponent };